import {Pagination, Table } from "antd";
import React from "react";
import { AiOutlineEye } from "react-icons/ai";
import API from "../../config/API";

function DataTable(props: any) {
  const columns = [
    {
      title: "Store Name",
      dataIndex: "store_name",
      key: "store_name",
    },
    {
      title: "Owner Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Phone",
      dataIndex: "phone",
      key: "phone",
      render: (item: string,record:any) => <span>{record?.code??''}{" "}{item}</span>,
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      render: (item: string) => item,
    },
    {
      title: "Business Type",
      dataIndex: "business_type",
      key: "business_type",
    },
    
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
    },

    {
      title: "View",
      key: "actions",
      width: 50,
      render: (_text: any, _record: any) => (
        <div
          style={{ display: "flex", justifyContent: "space-around" }}
          onClick={() => props?.viewDetailsPage(_record)}
        >
          <AiOutlineEye cursor="pointer" size={25} color={API.COLOR} />
        </div>
      ),
    },
  ];
  return (
    <div>
      <Table
        size="small"
        dataSource={props.data}
        columns={columns}
        onRow={(record, rowIndex) => {
          return {
            onClick: (event) => {},
          };
        }}
        pagination={false}
      />
      <div className="d-flex justify-content-center mt-3">
        <Pagination
          current={props?.page || 1}
          pageSize={props?.pageSize || 10}
          total={props?.meta?.itemCount || 0}
          defaultCurrent={1}
          responsive={true}
          defaultPageSize={props?.pageSize || 10}
          disabled={false}
          hideOnSinglePage={true}
          onChange={(current: any, size: any) => {
            props?.changePage(current);
          }}
        />
      </div>
    </div>
  );
}

export default DataTable;
